export default {
  leads: [],
  totalLeads: "",
  lead: null,
  auth: "",
  groups: [],
  teams: [],
  unreadnotifications: [],
};
